module.exports = __webpack_public_path__ + "img/firewall-ability.1bb527e 1.efab6db.svg";